import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import {
  apiActionResult,
  apiActions as commonApiActions,
  apiResourceActionCreator
} from '../../common';
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';
import { default as setTaskSuccess } from './setTaskSuccess';

const actions = createActions({
  TASK: {
    PATCH_TASK: (taskId, isArchived, callback) => ({
      taskId,
      isArchived,
      callback
    }),
    API: {
      PATCH_TASK: apiResourceActionCreator('task')
    }
  }
});

export const apiAction = (authToken, formData, taskId) =>
  commonApiActions.authenticated.patch(
    `${API_ENDPOINT}/${taskId}`,
    authToken,
    formData,
    actions.task.api.patchTask
  );

function* patchTask(action) {
  const authToken = yield select(authTokenSelector);

  const { taskId, isArchived } = action.payload;
  const formData = { isArchived };

  yield put(apiAction(authToken, formData, taskId));

  const result = yield apiActionResult(actions.task.api.patchTask);

  if (result.success) {
    action.payload.callback();
    yield put(
      setTaskSuccess.action.task.setTaskSuccess({
        success: true,
        info: 'Task successfully updated.'
      })
    );
  } else {
    yield put(
      setTaskSuccess.action.task.setTaskSuccess({
        success: false,
        info: 'Task update failed.'
      })
    );
  }
}

const configuration = {
  name: 'patchTask',
  action: actions,
  sagas: patchTask,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      task: action.payload.task,
      isFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false
    })
  }
};

export default configuration;



// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/patchTask.js